export const TOOL_ACCESS_POLICIES = {
  TOOL_ADMINISTRATION: 'ToolAdministration'
} as const;

export type ToolAccessPermissionPolicy = (typeof TOOL_ACCESS_POLICIES)[keyof typeof TOOL_ACCESS_POLICIES];
